import { object, string } from 'yup';
import { useMemo } from 'react';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { IForgotPasswordFormData } from '../../../domain/models/IForgotPasswordFormData';

export function useForgotPasswordSchema() {
	const { t } = useTranslation();

	const schema = useMemo(
		() =>
			object<IForgotPasswordFormData>({
				email: string()
					.email(t('user_form_email_pattern_error'))
					.required(t('email_form_field_error')),
			}).required(),
		[t],
	);

	return schema;
}
